
export type Contractor = {
  id: string;
  name: string;
  service_type: string;
  address: string;
  phone: string;
  website?: string;
  rating: number;
  review_count: number;
  featured: boolean;
  gmb_link?: string;
  logo_link?: string;
  location: string;
  slug: string;
  created_at: string;
  updated_at: string;
};

export type ViewMode = "grid" | "list";

export const validLocations = [
  "oklahoma-city",
  "edmond",
  "norman"
] as const;

export type Location = typeof validLocations[number];
